/**
 * [INPUT]: 依赖 CartesianRoot 结构根与 BarCanvas 柱形绘制器
 * [OUTPUT]: 对外提供 BarChart 组合根
 * [POS]: dither-kit 分组/堆叠柱形入口，将根状态与柱绘制算法组合
 * [PROTOCOL]: 变更时更新此头部，然后检查 CLAUDE.md
 */
import { BarCanvas } from "./bar-canvas"
import { CartesianRoot } from "./cartesian-root";

/** Composable dither **bar** chart — `<Bar>` series, grouped or stacked. */
export function BarChart(props) {
  return <CartesianRoot chartType="bar" Canvas={BarCanvas} {...props} />;
}
